import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from "@mui/material";
import PropTypes from "prop-types";

function PreviewModal({ open, onClose, previews }) {
  const { label, imageUrl } = previews[0] || {};

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "70vw !important",
          height: "70vh !important",
          maxWidth: "none",
        },
      }}
    >
      {label && (
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: 20,
            backgroundColor: "#f5f5f5",
            borderBottom: "1px solid #ddd",
          }}
        >
          {label}
        </DialogTitle>
      )}

      <DialogContent
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "auto",
          backgroundColor: "#fafafa",
          p: 2,
        }}
      >
        {imageUrl ? (
          <Box
            component="img"
            src={imageUrl}
            alt="preview"
            sx={{
              width: "60vw",
              height: "50vh",
              objectFit: "contain",
              borderRadius: 2,
              border: "1px solid #ccc",
              boxShadow: 3,
            }}
          />
        ) : (
          <Box>Không có ảnh để xem trước</Box>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "flex-end",
          backgroundColor: "#f5f5f5",
          borderTop: "1px solid #ddd",
        }}
      >
        <Button onClick={onClose} variant="contained" color="primary">
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  previews: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      imageUrl: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default PreviewModal;
